;(function () {
	let testimonialsSlider = () => {
		$('.testimonials-section').each(function () {
			if ($(this).hasClass('slider_started')) {
				return ''
			}

			$(this).addClass('slider_started')
			let id = $(this).attr('id')
			let section = $(this)
			let layout = section.data('layout')
			let isVideoLayout = layout === 'video'
			let counterCurrent = section.find('.testimonials__counter-current')
			let counterTotal = section.find('.testimonials__counter-total')
			let totalSlides = section.find('.testimonials__slide').length

			// Calculate slides per view based on screen size
			let getSlidesPerView = () => {
				if (isVideoLayout) {
					if (window.innerWidth >= 1200) {
						return 5
					} else if (window.innerWidth >= 750) {
						return 3
					}
					return 1.15
				}

				if (window.innerWidth >= 990) {
					return 3
				} else if (window.innerWidth >= 750) {
					return 2
				}
				return 1
			}

			// Calculate total pages based on slides per view
			let getTotalPages = () => {
				let slidesPerView = getSlidesPerView()
				return Math.max(1, totalSlides - slidesPerView + 1)
			}

			// Update counter and navigation buttons
			let updateCounter = (swiper) => {
				if (!swiper) return

				let activeIndex = swiper.activeIndex
				let currentPage = activeIndex + 1
				let totalPages = getTotalPages()

				if (isVideoLayout) {
					totalPages = totalSlides
				}

				if (counterCurrent.length) {
					counterCurrent.text(currentPage)
				}
				if (counterTotal.length) {
					counterTotal.text(totalPages)
				}
			}

			// Initialize Swiper
			let swiperParams = {
				slidesPerView: isVideoLayout ? 1.15 : 1,
				spaceBetween: isVideoLayout ? 16 : 24,
				watchSlidesProgress: true,
				updateOnWindowResize: true,
				allowTouchMove: true,
				slidesPerGroup: 1,
				centeredSlides: isVideoLayout,
				slideToClickedSlide: isVideoLayout,
				breakpoints: {
					750: {
						slidesPerView: isVideoLayout ? 3 : 2,
						spaceBetween: 24,
						slidesPerGroup: 1,
					},
					990: {
						slidesPerView: isVideoLayout ? 4 : 3,
						spaceBetween: isVideoLayout ? 28 : 36,
						slidesPerGroup: 1,
					},
					1200: {
						slidesPerView: isVideoLayout ? 5 : 3,
						spaceBetween: isVideoLayout ? 32 : 36,
						slidesPerGroup: 1,
					},
				},
				on: {
					init: function (swiper) {
						updateCounter(swiper)
					},
					slideChange: function (swiper) {
						updateCounter(swiper)
					},
					resize: function (swiper) {
						updateCounter(swiper)
					},
				},
			}

			// Add navigation
			swiperParams.navigation = {
				nextEl: `#${id} .swiper-button-next__testimonials`,
				prevEl: `#${id} .swiper-button-prev__testimonials`,
			}

			let swiper = new Swiper(`#${id} .testimonials__slider`, swiperParams)
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		testimonialsSlider()
	})

	document.addEventListener('shopify:section:load', function () {
		testimonialsSlider()
	})

	document.addEventListener('shopify:section:reorder', function () {
		testimonialsSlider()
	})

	// Initialize on page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', testimonialsSlider)
	} else {
		testimonialsSlider()
	}
})()
